import useGetVehicle from '../hooks/useGetVehicle';
import Gallery from '../ui/Gallery';

const VehicleGallery = () => {
  const { vehicle } = useGetVehicle();

  return (
    <Gallery
      // min-h-0 fixes height issue
      className="w-full min-h-0 mb-8 md:mb-0"
      items={vehicle.pictures}
    />
  );
};

export default VehicleGallery;
